import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '单据编码',
            prop: 'billCode',
            type: 'slot',
            minWidth: 120
        },
        {
            label: '内外销',
            prop: 'isImpExpCustomer',
            type: 'select',
            optionsKey: 'IS_IMP_EXP_CUSTOMER',
            minWidth: 90
        },
        {
            label: '客户分类',
            prop: 'ebcuCustomerType',
            type: 'select',
            optionsKey: 'EBCU_CUSTOMER_TYPE_OVERSEAS',
            minWidth: 90
        },
        {
            label: '销售产品',
            prop: 'salesProduct',
            minWidth: 80
        },
        {
            label: '是否涉及危险品',
            prop: 'isHazardous',
            type: 'select',
            optionsKey: 'SYS_IS_HAZARDOUS',
            minWidth: 160
        },
        {
            label: '预计合作规模（万元）',
            prop: 'estimatedScale',
            minWidth: 160
        },
        {
            label: '预计采购毛利率(%)',
            prop: 'estimatedGrossMargin',
            minWidth: 120
        },
        {
            label: '总账期（天）',
            prop: 'creditPeriodDays',
            minWidth: 90
        },
        {
            label: '投标押金(万元)',
            prop: 'tenderDeposit',
            minWidth: 90
        },
        {
            label: '运作押金(万元)',
            prop: 'operationDeposit',
            minWidth: 80
        },
        {
            label: '大航线',
            prop: 'routeCodes',
            type: 'custom',
            // type: 'select',
            // multiple: true,
            // optionsKey: 'SYS_ROUTE_TYPE',
            minWidth: 160
        },
        {
            label: '所属部门',
            prop: 'departmentName',
            minWidth: 160
        },
        {
            label: '审批状态',
            prop: 'approvalStatus',
            type: 'select',
            optionsKey: 'SYS_SU_MIP_AUDIT_STATUS',
            minWidth: 160
        },
        {
            label: '审批时间',
            prop: 'approvalTime',
            minWidth: 160
        },
        {
            label: '创建人',
            prop: 'createUserName',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '删除',
                event: 'delete',
                displayRule: (row) => {
                    const auth = otherUtils.getHasAuth(
                        btnAuthority.customerManage.subOverseasIntroductionDelete
                    );
                    // 没有关联流程信息或者关联的流程信息的状态 = 草稿时
                    return auth && ['', null, undefined, '1'].includes(row.approvalStatus?.toString());
                }
            },
            {
                label: '审批',
                event: 'change',
                displayRule: (row) => {
                    const auth = otherUtils.getHasAuth(
                        btnAuthority.customerManage.subOverseasIntroductionFlow
                    );
                    // 没有关联流程信息或者关联的流程信息的状态 = 草稿时
                    return auth && ['', null, undefined, '1', '5', '6'].includes(row.approvalStatus?.toString());
                }
            }
        ]
    }
};
